import Animation from 'Modules/Animation';

document.querySelectorAll('.pages-sidebar .toggle').forEach((toggle) =>
  toggle.addEventListener('click', (e) => {
    e.preventDefault();
    Animation.slideToggle(
      e.target.parentNode.parentNode.querySelector('.children')
    );
  })
);
